import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

/**
 * @param {{ data: Object, onChange: (next: Object) => void, disabled?: boolean, showEncoFields?: boolean }} props
 */
const EditableQuoteHeaderForm = ({ data, onChange, disabled = false, showEncoFields = false }) => {
  const patch = (section, field, value) => {
    onChange({
      ...data,
      [section]: { ...data[section], [field]: value },
    });
  };

  const field = (label, section, key, className = '') => (
    <Form.Group as={Col} md={6} className="mb-2">
      <Form.Label className="small mb-0">{label}</Form.Label>
      <Form.Control
        size="sm"
        disabled={disabled}
        className={className}
        value={data[section]?.[key] ?? ''}
        onChange={e => patch(section, key, e.target.value)}
      />
    </Form.Group>
  );

  const numField = (label, section, key) => (
    <Form.Group as={Col} md={4} className="mb-2">
      <Form.Label className="small mb-0">{label}</Form.Label>
      <Form.Control
        size="sm"
        type="number"
        step="any"
        disabled={disabled}
        className="currency-value number-value"
        value={data[section]?.[key] ?? ''}
        onChange={e => {
          const v = e.target.value;
          patch(section, key, v === '' ? null : Number(v));
        }}
      />
    </Form.Group>
  );

  return (
    <div>
      <h6 className="mb-2">Quote</h6>
      <Row>
        {field('Quote number', 'quote', 'quoteNumber', 'catalog-number')}
        {showEncoFields && field('Quote date', 'quote', 'quoteDate')}
        {field('Currency', 'quote', 'currency', 'currency-value')}
        {showEncoFields && numField('Subtotal before discount', 'quote', 'subtotalBeforeDiscount')}
        {showEncoFields && numField('Subtotal', 'quote', 'subtotal')}
        {showEncoFields && numField('General discount', 'quote', 'generalDiscount')}
        {showEncoFields && numField('Total after discount', 'quote', 'totalAfterDiscount')}
      </Row>
    </div>
  );
};

export default EditableQuoteHeaderForm;
